<script>
  let footbarIsOpen = false;
  import { fly } from "svelte/transition";

  import Emoji from "@helpers/Emoji.svelte";
</script>

<!-- {#if !footbarIsOpen} -->
<span
  class="open"
  on:click={() => {
    footbarIsOpen = true;
  }}>?</span
>
<!-- {/if} -->
{#if footbarIsOpen}
  <div class="footbar" transition:fly={{ y: 1000, opacity: 1 }}>
    <div
      on:click={() => {
        footbarIsOpen = false;
      }}
    >
      <Emoji
        emoji="point-down"
        styles="width: 30px; height: 30px; bottom: .75rem; right: .75rem; cursor: pointer;"
      />
    </div>
    <!-- <h1>Dive Deeper</h1>
    <p class="subtitle">
      Here are more ways to get involved with the Houston Budget.
    </p> -->
    <h2>What's this?</h2>
    <p>
      This site was built by
      <a
        href="https://www.aclutx.org/"
        target="_blank"
        rel="noopener noreferrer">ACLU TX</a
      >,
      <a
        href="https://datatodream.com"
        target="_blank"
        rel="noopener noreferrer">Data to Dream</a
      >, and
      <a
        href="https://mokshadata.studio"
        target="_blank"
        rel="noopener noreferrer">Moksha Data Studio</a
      >, in an effort to centralize information about the Houston Budget and
      allow for easier engagement in the budget process.
    </p>

    <h2>Contact</h2>
    <p>
      Please direct all media inquiries to
      <a
        href="mailto:dream@houstonbudget.com"
        target="_blank"
        rel="noopener noreferrer">dream@houstonbudget.com</a
      >. Need technical help? Please email
      <a
        href="mailto:hello@mokshadata.studio"
        target="_blank"
        rel="noopener noreferrer">hello@mokshadata.studio</a
      >.
    </p>

    <h2>More info</h2>
    <p>
      Interested in getting involved further? Want to download the budget data
      and explore for yourself? Please visit our up-to-date resource page <a
        href="https://mokshadata.notion.site/FY23-Budget-Engagement-Resources-5749620c88c845f3acb196113420d230"
        target="_blank"
        rel="noopener noreferrer">here.</a
      >
    </p>
  </div>
{/if}

<style>
  .footbar {
    background: var(--primary-color);
    position: fixed;
    padding: 1rem;
    z-index: 10000;
    box-shadow: -20px 0px 200px black;
    overflow-y: auto;
    overflow-x: hidden;
    bottom: 0;
    left: 0;
    min-height: 15vh;
    width: 100vw;
  }

  h2 {
    text-transform: uppercase;
    font-size: 1.25rem;
    font-family: var(--font-serif);
    margin: 1.5rem 0 0.5rem 0;
    font-weight: 600;
    color: black;
  }

  h2:first-of-type {
    margin-top: 0.75rem;
  }

  p {
    font-size: 1rem;
    margin-bottom: 0.75rem;
    line-height: 1.35;
    font-weight: 300;
  }

  .open {
    background: var(--accent-color);
    width: 2rem;
    height: 2rem;
    border-radius: 1rem;
    color: var(--primary-color);
    position: fixed;
    bottom: 0.75rem;
    right: 0.75rem;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 6;
  }

  @media screen and (max-width: 768px) {
    .footbar {
      width: 100%;
    }
  }
</style>
